// extracted by mini-css-extract-plugin
export default {"front":"SpinnerIcon_front__kxQaY","back":"SpinnerIcon_back__rM3DZ","isSpinning":"SpinnerIcon_isSpinning__mikKD","spin":"SpinnerIcon_spin__H36ga"};